import React from 'react';
import Modal from 'react-modal';
import { useHistory, withRouter } from 'react-router-dom';
import { useQuery } from 'react-apollo';

import Button from '../../../global/Button';
import Spinner from '../../../global/Spinner';
import { isMemoryBook } from '../../../../util/album';
import useOpenModal from '../../../../hooks/useOpenModal';
import { CONTRIBUTOR_SHARE_MODAL } from '../../../../constants/modals';
import { AlbumWithEventSettings } from '../../../../graphql/queries/albums';
import ContributorShareModal from '../../../../apps/pro/components/ContributorShare/ContributorShare';
import { getCelebratedPersonName } from '../../../../apps/pro/views/AlbumFolder/FreemiumEvents/SpecialtyAlbumGreetingModal/helpers';
import FullScreenLoader from '../../../global/FullScreenLoader';
import useAuthenticated from '../../../../hooks/useAuthenticated';
import useBasename from '../../../routing/useBasename';
import { MeQuery } from '../../../../graphql/queries/account';
import { isAlbumOwner } from '../../../../util/account';
import Angle from '../../../global/Angle';
import {
  isNativeAppWebView,
  postNativeAppAlbumSlideshowViewerDismiss,
  postNativeAppAlbumSlideshowViewerShareDialog,
  postNativeAppAlbumSlideshowViewerUpload,
} from '../../../../services/native-bridge/native-apps-interface';

const AlbumSlideshowSolicitation = ({ match }) => {
  const history = useHistory();
  const basename = useBasename();
  const openModal = useOpenModal();
  const authenticated = useAuthenticated();
  const { data: { me: user } = {} } = useQuery(MeQuery, {
    skip: !authenticated,
  });
  const { data: { album, loading } = {} } = useQuery(AlbumWithEventSettings, {
    variables: {
      id: match.params.albumId,
    },
    skip: !match?.params?.albumId,
  });

  const isOwner = isAlbumOwner(user, album);
  const isNativeView = isNativeAppWebView();
  const eventSettings = album?.root_album_folder?.event_settings;
  const posessiveCelebratedName = getCelebratedPersonName(
    album?.album_subtype,
    eventSettings,
    true,
    album?.root_album_folder?.account?.organization_name ??
      album?.root_album_folder?.account?.name,
  );

  const solicitationCopy = (() => {
    if (!album) {
      return '';
    }

    if (isOwner && isMemoryBook(album)) {
      return (
        <>
          Share your Memories Slideshow <br />
          &amp; let&apos;s collect some memories!
        </>
      );
    }
    return <>Add your photos to {posessiveCelebratedName} slideshow!</>;
  })();

  if (!match?.params?.albumId) {
    return <FullScreenLoader />;
  }

  return (
    <Modal
      isOpen
      ariaHideApp={false}
      bodyOpenClassName="body-modal-open"
      overlayClassName="slideshow-grid-viewer-overlay"
      className="slideshow-grid-viewer"
    >
      <Button
        btnStyle="reset"
        onClick={() => {
          if (isNativeView) {
            postNativeAppAlbumSlideshowViewerDismiss();
          } else {
            history.goBack();
          }
        }}
        className="video-slideshow-btn-dismiss text-lg"
      >
        <Angle direction="left" />
      </Button>
      <div className="slideshow-grid-viewer-body">
        <div className="slideshow-grid-viewer-content">
          {(!album || loading) && <Spinner />}
          {album && (
            <div className="video-slideshow-solicitation-box">
              <p className="text-white text-center text-bold">
                {solicitationCopy}
              </p>
              <Button
                btnBlock
                btnOutline
                btnStyle="white"
                onClick={() => {
                  if (isNativeView) {
                    postNativeAppAlbumSlideshowViewerUpload(album.id);
                  } else {
                    history.push(
                      `/s/event-invite/${album.root_album_folder.id}?target=${album.id}`,
                    );
                  }
                }}
              >
                Add your photos
              </Button>
              <Button
                btnBlock
                btnOutline
                btnStyle="white"
                onClick={() => {
                  if (isNativeView) {
                    postNativeAppAlbumSlideshowViewerShareDialog(album.id);
                  } else {
                    openModal(CONTRIBUTOR_SHARE_MODAL, {
                      albumId: album.id,
                    });
                  }
                }}
              >
                Share with others
              </Button>
              <Button
                btnBlock
                btnOutline
                btnStyle="white"
                onClick={() => {
                  history.replace(
                    basename
                      ? `/app/${basename}/albums/${album.id}/slideshow/greeting`
                      : `/albums/${album.id}/slideshow/greeting`,
                  );
                }}
              >
                Watch again
              </Button>
            </div>
          )}
        </div>
      </div>
      <ContributorShareModal />
    </Modal>
  );
};

export default withRouter(AlbumSlideshowSolicitation);
